import { render, staticRenderFns } from "./form-table.vue?vue&type=template&id=9425fce6&scoped=true"
import script from "./form-table.ts?vue&type=script&lang=ts&external"
export * from "./form-table.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9425fce6",
  null
  
)

export default component.exports